import { EFulfillmentMode } from "../../Enum/EFulfillmentMode"
import { EOrderCurrentStatus } from "../../Enum/EOrderCurrentStatus"
import { EOrderStatusType } from "../../Enum/EOrderStatus"
import { OrderEntity } from "../../Objects/Order/OrderEntity"

export type FulfillmentStation = "FULFILLMENT" | "SECONDARY"

export const getFulfillmentStationItems = (order: OrderEntity, station: FulfillmentStation, mode: EFulfillmentMode) => {
  if (mode !== EFulfillmentMode.Separated) {
    return order.getAllCatalogProducts()
  }

  return station === "SECONDARY" ? order.orderCatalogItems : order.orderProducts
}

export const countOpenFulfillmentOrders = (
  orders: OrderEntity[],
  station: FulfillmentStation,
  mode: EFulfillmentMode,
) =>
  orders.filter((order) => {
    if (order.eOrderStatusType === EOrderStatusType.Delivered) {
      return false
    }

    return getFulfillmentStationItems(order, station, mode).some(
      (item) => item.currentStatus !== EOrderCurrentStatus.Closed,
    )
  }).length
